import React, { useContext, useEffect } from "react";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";

import { IonContent, useIonRouter } from "@ionic/react";

// @ts-ignore
import "@wearesweet/sendbird-uikit-react/dist/index.css";
import "./UIKit.scss";

import { App } from "@capacitor/app";
import { useSendbirdStateContext } from "@wearesweet/sendbird-uikit-react";
import { PageHeader } from "../../components/PageHeader";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { registerUnreadListener, updateUnreadBadge } from "../../utils/updateUnreadBadge";
import { useViewport } from "../../utils/useViewport";
import { ChatDesktop } from "./desktop/ChatDesktop";

const Chat = (props: any) => {
  const { isMobile } = useViewport();
  const state = useSendbirdStateContext();
  const { setNumUnreadMessages } = useContext(AuthenticatedUserContext);
  const router = useIonRouter();

  useEffect(() => {
    if (isMobile) {
      router.push("/mchat");
    }
  }, [router, isMobile]);

  useEffect(() => {
    registerUnreadListener(state, setNumUnreadMessages);
    updateUnreadBadge(state, setNumUnreadMessages);
  }, [state, setNumUnreadMessages]);

  App.addListener("appStateChange", () => {
    updateUnreadBadge(state, setNumUnreadMessages);
  });

  return isMobile ? (
    <></>
  ) : (
    <BasicTemplate className="page-chat-list" hideHeader={false} hideBackButton={true}>
      {state.stores.sdkStore.error ? (
        <IonContent fullscreen={true} class={"ion-padding"}>
          <PageHeader>Error</PageHeader>
          <p>An error occurred communicating with the chat engine.</p>
        </IonContent>
      ) : (
        <ChatDesktop />
      )}
    </BasicTemplate>
  );
};

export default Chat;
